/**
 * copilotBridge (UPT-2126 A3, spec §5.5) — ouvrir le chat du copilote depuis n'importe quelle page du portail.
 *
 * Aucune API publique d'ouverture n'existait : l'état `open` du tiroir est interne. Le pont est un évènement
 * `window` ; `CopilotDrawer` l'écoute (un seul tiroir est monté, sous le layout du portail) et ignore l'évènement
 * hors route portail ou sans session.
 *
 * `prompt` : texte envoyé au copilote comme si l'utilisateur l'avait tapé. L'appelant ne le déclenche qu'au CLIC
 * de l'utilisateur (le budget IA du locataire n'est consommé que par une action) ; le tiroir l'ignore quand un tour
 * est déjà en cours.
 */
export const COPILOT_OPEN_EVENT = 'geode:copilot-open';

export type CopilotOpenDetail = {
  prompt?: string;
};

/** Ouvre le tiroir du copilote ; avec `prompt` non vide, envoie aussi ce message (une fois). */
export function openCopilot(detail?: CopilotOpenDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<CopilotOpenDetail>(COPILOT_OPEN_EVENT, { detail: detail ?? {} }));
}

/** Lit le texte d'un évènement d'ouverture (vide si absent ou non textuel). */
export function promptOf(event: Event): string {
  const detail = (event as CustomEvent<CopilotOpenDetail | undefined>).detail;
  const prompt = detail?.prompt;
  return typeof prompt === 'string' ? prompt.trim() : '';
}
